import { InjectionToken } from '@angular/core';
import { BaseFilterSettingsDefault } from '../../dependencies/wlm-filters/base-filter-settings';

export const BASE_FILTER_SETTINGS_DEFAULT = new InjectionToken<BaseFilterSettingsDefault>(
  'BASE_FILTER_SETTINGS_DEFAULT'
);
